<template>
	<div id="content_body">
		<header-layout :pageHeaderStyle="pageHeaderStyle" :pageHeaderBg="pageHeaderBg" :pageHeaderSpacing="pageHeaderSpacing" :pageHeaderContainer="pageHeaderContainer" :instanceClass="instanceClassAttr.instanceClass" :pageIcon="pageIcon"></header-layout>
		<div class="container mt-n15">
			<!-- :accordion="false" -->
			<vue-collapsible-panel-group>
				<vue-collapsible-panel>
					<template #title>{{ $t('panel.criteria') }}</template>
					<template #content>
						<!-- CRITERES SEARCH -->
						<div class="datatable">
							<div class="card mb-4" style="width:100%">
								<div class="card-header">
									<!-- <div id="panelList" class="card-body  panel-collapse collapse in show"> -->
									<div class="form-row">
										<div class="col-md-4">
											<div class="form-group">
												<label>{{ $t('default.amountInf', { obj: $t(instanceClassAttr.instanceClass+'.profit')} ) }}</label>
												<input type="number" step="any" v-model="instance.profitInf" class="form-control" @input="amountToLetter($event, 'inf')" @change="amountLetter = {}"/>
												<span v-if="amountLetter && amountLetter.inf != '' " class="amount-letter">
													{{amountLetter.inf}}
												</span>
											</div>
										</div>
										<div class="col-md-4">
											<div class="form-group">
												<label>{{ $t('default.amountEq', { obj: $t(instanceClassAttr.instanceClass+'.profit')})}}</label>
												<input type="number" step="any" v-model="instance.profitEq" class="form-control" @input="amountToLetter($event, 'eq')" @change="amountLetter = {}"/>
												<span v-if="amountLetter && amountLetter.eq != '' " class="amount-letter">
													{{amountLetter.eq}}
												</span>
											</div>
										</div>
										<div class="col-md-4">
											<div class="form-group">
												<label>{{ $t('default.amountSup', { obj: $t(instanceClassAttr.instanceClass+'.profit')})}}</label>
												<input type="number" step="any" v-model="instance.profitSup" class="form-control" @input="amountToLetter($event, 'sup')" @change="amountLetter = {}"/>
												<span v-if="amountLetter && amountLetter.sup != '' " class="amount-letter">
													{{amountLetter.sup}}
												</span>
											</div>
										</div>
										<div class="col-md-6">
											<div class="form-group">
												<label>{{ $t('default.dateEntryAfter')}}</label>
												<input type="date" v-model="instance.dateEntryAfter" class="form-control" />
											</div>
										</div>
										<div class="col-md-6">
											<div class="form-group">
												<label>{{ $t('default.dateEntryBefore')}}</label>
												<input type="date" v-model="instance.dateEntryBefore" class="form-control" />
											</div>
										</div>
									</div> <!--end form-row-->
									<div style="text-align:center">
										<b-button class="btn btn-primary btn-sm"
											@click="search()">
											<fa icon="search"/>
												&nbsp; {{ $t('vtabTrans.sSearch') }}
										</b-button>
										&ensp;
										<button class="btn btn-light btn-sm" @click="reset()">
											<fa icon="refresh"/>
											&nbsp; {{ $t('vtabTrans.sReset') }}
										</button>
									</div>

										<!-- </div> -->
								</div>
							</div> <!--end card-body-->
						</div>
					</template>
				</vue-collapsible-panel>
				<br>
				<!-- STATS -->
				<vue-collapsible-panel :expanded="false">
					<template #title>{{ $t('panel.chart') }}</template>
					<template #content>
						<div>
							<chart
								:typeStats="typeStats"
								:chartData="chartData"
								:chartOptions="chartOptions"
								@refreshChart="drawChart"
							/>
						</div>
					</template>
				</vue-collapsible-panel>
				<br>
				<vue-collapsible-panel>
					<template #title>{{ $t('panel.data') }}</template>
					<template #content>
						<!-- DATA -->
						<div class="datatable">
							<datatable-instance
								:instanceClassAttr="instanceClassAttr"
								ref="componentDatatableInstance"
								@refreshChart="drawChart"
							/>
						</div>
					</template>
				</vue-collapsible-panel>
				
			</vue-collapsible-panel-group>
		
		</div>
	</div>

</template>
<script>
	import Header from '@/layouts/templates/Header.vue';
	import DatatableInstance from '@/components/templates/datatables/DatatableInstance.vue';
	import Chart from '@/components/templates/charts/Chart.vue';

	export default {
		name: 'mvtInventoryList',
		components: {
			'header-layout': Header,
			'datatable-instance': DatatableInstance,
			'chart': Chart
		},
		data() {
			return {
				pageHeaderStyle: process.env.VUE_APP_PAGE_HEADER_STYLE,
				pageHeaderBg: process.env.VUE_APP_PAGE_HEADER_BG,
				pageHeaderSpacing: 'pb-10',
				pageHeaderContainer: 'container',
				pageSubtitle: this.$t('mvtinventory.label'),
				pageTitle: this.$t('mvtinventory.list'),
				pageIcon: 'list',
				instanceClassAttr: {
					instanceClass: 'mvtinventory',
					routerShow: 'mvtinventoryshow',
					titleIndex: 'nav.mvt',
					iconClass: 'folder',
					actCol: {
						actDisplay: true, 
						thCol: '7%', 
						actAdd: true, 
						actGet: true, 
						actEdit: false, 
						actDel: false, 
						actPrint: 'produce'
					},
					attrsList: [
						{attrName: 'lib', attrCol: '35%', searchable: true, sortable: true, attrRep: 'toStringRep()'},
						// {attrName: 'dateStart', attrCol: '10%', searchable: false, sortable: true},
						// {attrName: 'dateEnd', attrCol: '10%', searchable: false, sortable: true},
						{attrName: 'lastSolde', attrCol: '12%', searchable: false, sortable: true, attrRep: ''},
						{attrName: 'newSolde', attrCol: '12%', searchable: false, sortable: true, attrRep: ''},
						{attrName: 'profit', attrCol: '15%', searchable: false, sortable: true},
						{attrName: 'dateCreated', attrCol: '10%', searchable: false, sortable: true},
					]
				},
				instance: {
					amountTotStock: 0,
					amountTotStockOngoing: 0,
					accountTot: 0,
					lastSolde: 0,
					newSolde: 0,
					profit: 0,

					amountCredit: 0,
					amountDebit: 0,
					amountRefund: 0,
					amountZakat: 0,
					amountDebitInLoss: 0,

					username:'',
					profitInf: '',
					profiteq: '',
					profitSup: '',
					dateEntryAfter:'',
					dateEntryBefore:''
				},

				userList: [],
				amountLetter: {},
				chartOptions: {
					title: 'Statistique des inventaires par ',
					hAxis: {title: 'Exercice'},
					vAxis: {title: 'Bénéfice'},
					recap: {title: 'Bénéfices totaux', val:0}
				},
				chartData: [],
				typeStats: [
					{id: 'libShort', label: 'Exercice'},
				],
				typeStat: 'libShort',
			}
		},
		async mounted () {
			this.reset()
		},
		methods: {
			reset(){
				this.instance= {
					profitInf: '',
					profiteq: '',
					profitSup: '',
					dateEntryAfter:'',
					dateEntryBefore:''
				}
			},
			async amountToLetter(e, attrName) {
				if(e.target.value && e.target.value.length > 2 && attrName && attrName != ''){
					await this.$store.dispatch('axiosGet', { url: '/api/sequence/convert?amount='+e.target.value
					})
					.then(response => {
						if(response.data && response.data.results)
							this.amountLetter[attrName] = response.data.results
					}).catch(error => {
						console.log('error catch convert amount == ', error.message)
					})
				}
			},
			async search() {
				let strParamsForms = "";

				let titreDoc = this.$t(this.instanceClassAttr.instanceClass +'.list')
				
				let	detailsTopC1 = '';
				let	detailsTopC2 = '';

				// Date super
				strParamsForms = strParamsForms+"&params1=dateCreated&valParams1="+this.instance.dateEntryAfter+"&logParams1=geD"
				if(this.instance.dateEntryAfter){
					detailsTopC1 = '<i>'+this.$t('default.dateEntryAfter')+' </i><b> '+ this.$moment(this.instance.dateEntryAfter).format(this.$store.getters.formatDateShort) + '</b>'
				}
				// Date inf
				strParamsForms = strParamsForms+"&params2=dateCreated&valParams2="+this.instance.dateEntryBefore+"&logParams2=leD"
				if(this.instance.dateEntryBefore){
					if(detailsTopC1 != '')
						detailsTopC1 = detailsTopC1 + ' - '
					else
						detailsTopC1 = detailsTopC1 + '<i>'+this.$t('default.dateEntryAfter')+' </i><b> ... </b>'

					detailsTopC1 = detailsTopC1 + '<i>'+this.$t('default.dateEntryBefore')+' </i><b> '+ this.$moment(this.instance.dateEntryBefore).format(this.$store.getters.formatDateShort) + '</b>'
				}
				// Amout super
				strParamsForms = strParamsForms+"&params6=profit&valParams6="+this.instance.profitSup+"&logParams6=geDo"
				if(this.instance.profitSup){
					if(detailsTopC2 != '')
						detailsTopC2 = detailsTopC2 + '<br>'
					detailsTopC2 = detailsTopC2 + '<i>'+this.$t(this.instanceClassAttr.instanceClass +'.profit')+' > </i><b> '+this.$store.getters.formatAmount(this.instance.profitSup) + '</b>'
				}
				// Amout equal
				strParamsForms = strParamsForms+"&params7=profit&valParams7="+this.instance.profitEq+"&logParams7=eqDo"
				if(this.instance.profitEq){
					if(detailsTopC2 != '')
						detailsTopC2 = detailsTopC2 + '<br>'
					detailsTopC2 = detailsTopC2 + '<i>'+this.$t(this.instanceClassAttr.instanceClass +'.profit')+' = </i><b> '+this.$store.getters.formatAmount(this.instance.profitEq) + '</b>'
				}
				// Amout inf
				strParamsForms = strParamsForms+"&params8=profit&valParams8="+this.instance.profitInf+"&logParams8=leDo"
				if(this.instance.profitInf){
					if(detailsTopC2 != '')
						detailsTopC2 = detailsTopC2 + '<br>'
					detailsTopC2 = detailsTopC2 + '<i>'+this.$t(this.instanceClassAttr.instanceClass +'.profit')+'< </i><b> '+this.$store.getters.formatAmount(this.instance.profitInf) + '</b>'
				}

				strParamsForms = strParamsForms+ "&titreDoc="+ titreDoc
				if(detailsTopC1 != '')
					strParamsForms = strParamsForms+"&detailsTopC1="+detailsTopC1
				if(detailsTopC2 != '')
					strParamsForms = strParamsForms+"&detailsTopC2="+detailsTopC2
				
				this.$refs.componentDatatableInstance.setStrParamsForms(strParamsForms);
				this.$refs.componentDatatableInstance.getDataByCriteria();
			},
			drawChart(val) {
				if(val && !Array.isArray(val))
					this.typeStat = val
				
				// default values
				let statLabel = ["Exercice", "Bénéfice par Exercice"] 
				let attrKey = 'libShort'
				let attrValue = 'profit'
				
				var dataList = this.$refs.componentDatatableInstance.drawChart(attrKey, attrValue, null)
				this.chartData = [ statLabel ]
				let sumData = 0;
				dataList?.forEach(data => {
					this.chartData.push(data);
					sumData = sumData + data[1]
				});
				this.chartOptions.recap.val = this.$store.getters.formatAmount(sumData)
				if(this.chartOptions.recap.title && this.chartOptions.recap.val){
					let detailsBot = '&detailsBot=<i> '+ this.chartOptions.recap.title +' : <b> '+ this.chartOptions.recap.val +'</b> </i>';
					this.$refs.componentDatatableInstance.addStrParamsForms(detailsBot);
				}
			},
		}
		
	}

</script>
